import React from 'react';
import EmployeeLeaveRequestFunctional from './component/functional';

const EmployeeLeaveRequestMain = () => {
	return <EmployeeLeaveRequestFunctional />;
};

export default EmployeeLeaveRequestMain;
